import Crud from '../views/ModeloPergunta/Crud'
import Entity from '../views/ModeloPergunta/Add'

let routes = {
    path: '/modelo_perguntas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/modelo_perguntas/add',
            name: 'NewModeloPergunta',
            component: Entity
        },
        {
            path: '/modelo_perguntas/edit/:id?',
            name: 'EditModeloPergunta',
            component: Entity
        },
        {
            path: '/modelo_perguntas',
            name: 'list-modelo_perguntas',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Modelos de Perguntas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
